import { call, put, takeLatest } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';
import accountApi from '../../api/AccountApi';
import { AccessRights, Account } from '../../types/user';
import { userAccessRightsActions, userActions } from '../actions/creators';

function* userSaga() {
  yield takeLatest(getType(userActions.getUser), fetchUser);
}

export function* fetchUser() {
  yield put(userActions.fetchUser.request());
  try {
    const accountPayload: Account = yield call(accountApi.getAccount);
    if (accountPayload) {
      yield put(userActions.fetchUser.success(accountPayload));
      yield call(fetchUserAccessRights);
    } else {
      yield put(
        userActions.fetchUser.failure({
          data: { statusCode: 400, isSuccesful: false, errorMessage: 'could not get user' },
          status: 400,
        })
      );
    }
  } catch (e) {
    yield put(userActions.fetchUser.failure(e.response));
  }
}

function* fetchUserAccessRights() {
  yield put(userAccessRightsActions.fetchUserAccessRights.request());
  try {
    const accessRightsPayload: AccessRights = yield call(accountApi.getAccessRights);
    yield put(userAccessRightsActions.fetchUserAccessRights.success(accessRightsPayload));
  } catch (e) {
    yield put(userAccessRightsActions.fetchUserAccessRights.failure(e.response));
  }
}

export default userSaga;
